import { Injectable } from '@angular/core';
import {RecordTableAction} from "../../../types/record-table-action.types";

@Injectable({
  providedIn: 'root'
})
export class ActionDropdownMenuService {
  public getLabelByAction(action: RecordTableAction): string {
    switch (action) {
      case 'DOWNLOAD_EXCEL': return 'Скачать Excel';
      case 'DOWNLOAD_OLD_FORMAT_EXCEL': return 'Скачать Excel (старый формат)';
      case 'UNBIND_BLOGGER': return 'Отвязать блогера';
      case 'UNBIND_CONTACT': return 'Отвязать контакт';
      case 'DELETE_CONTACT': return 'Удалить контакт';
      case 'EDIT_BLOGGER': return 'Редактировать блогера';
      case 'EDIT_PROFILES_BLOGGER': return 'Редактировать ссылки';
      case 'CREATE_PROFILE_BLOGGER': return 'Добавить ссылку';
      case 'DELETE_PROFILE_BLOGGER': return 'Удалить ссылку';
      case 'UNBIND_BANK_DETAILS': return 'Отвязать реквизиты';
      case 'DELETE_BANK_DETAILS': return 'Удалить реквизиты';
      case 'UNBIND_ADVERTISEMENT_PACKAGE': return 'Отвязать рекламу от пакета';
      case 'ADD_ADVERTISEMENT_PACKAGE': return 'Объединить (Создать пакет)';
      case 'RESIZE_COLUMN': return 'Изменить размер колонок';
      case 'VIEW_BLOGGER_GROUPS': return 'Отвязать блогера от группы';
      case 'UNBIND_CUSTOMER': return 'Отвязть покупателя';
      case 'UNBIND_PRODUCT_CARD': return 'Отвязать карту продукта';
      case 'UPLOAD_EXCEL': return 'Загрузить Excel';
      case 'PRICE_LEVEL_CONFIG_COPY': return 'Создать копию';
      case 'RRC_LIMIT_COPY': return 'Создать копию';
      default: return '';
    }
  }
}
